const translations = {
    battery: 'Battery',
    drone: 'Drone'
};

export default translations;
